module.exports = __webpack_public_path__ + "src/assets/img/280x200_twichend.aa539ec2.jpg";